<div class="status-select__window dialog__window">
  <div class="status-select__header dialog__header">
    <div class="status-select__title dialog__title">Смена статуса задачи</div>
    <div class="status-select__close dialog__close" (click)="onClose()"><i class="icon-close"></i></div>
  </div>

  <div class="status-select__description dialog__description">
    <div class="status-select__description-content dialog__description-content">
      Выберите статус в который будет переведена задача из проекта "{{ projectName() }}"
    </div>
  </div>

  <div class="status-select__content dialog__content">
    <div class="status-select__list dialog__list">
      @for (status of statuses(); track status.id) {
        <div class="status-select__item dialog__item" (click)="onSelectStatus(status)">
          <div class="status-select__item-color dialog__item-color" [style.background-color]="status.color"></div>
          <div class="status-select__item-name dialog__item-name">{{ status.name }}</div>
        </div>
      }
    </div>
  </div>
</div>
